import { useSelector } from "react-redux";
import { RootState } from "../slices";

export const updateDetailsStateSelector = (state: RootState) =>
  state.updateMyDetailsCreate;
export const useUpdateDetailsStateSelector = () =>
  useSelector(updateDetailsStateSelector);
